import type React from "react";

import { useTranslation } from "react-i18next";
import { TableCell, TableRow } from "src/primitives/Table";

interface EmptyStateProps {
  colSpan: number;
  message?: string | React.ReactNode;
}

export const EmptyState = ({ colSpan, message }: EmptyStateProps) => {
  const { t } = useTranslation();
  const resolvedMessage =
    message ?? t("neetoatoms.dataTable.noResults", "No results.");

  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        className="min-h-24 text-center text-muted-foreground"
      >
        {resolvedMessage}
      </TableCell>
    </TableRow>
  );
};
